import {AIContent} from "./aiContent.model";
import {AITranscript} from "./aiTranscript.model";
import {AIDocumentPage} from "./aiDocumentPage";

export class AISubChapter {
    title: string;
    number: number;
    id?: number;
    content: AIContent;
    transcript: AITranscript;
    documentPages: AIDocumentPage[];
    chapterID:string;
    autoTranscriptStatus: AutoTranscriptStatus

    constructor() {
        this.title = "";
        this.number = 0;
        this.content = new AIContent();
        this.transcript = new AITranscript();
        this.documentPages=[];
      this.autoTranscriptStatus = AutoTranscriptStatus.NA;
      this.chapterID=""

    }
}

export enum AutoTranscriptStatus {
  NONE='NONE',
  WAITING='WAITING',
  DONE='DONE',
  ERROR='ERROR',
  NA='NA'
}
